///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.form_manager = abcsetup.form_manager || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.form_manager.form = null;




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.form_manager = {

    /**
     * Loop through the current global abcsetup.item and set form fields values
     */
    setFormItems: function(viewOnly = false) {
        // Update the form fields
        for (var i in abcsetup.item) {
            if (abcsetup.item[i] !== null) {
                //console.log(i + ' :: ' + $.type(abcsetup.item[i]));
                this._setFieldValue(i, abcsetup.item[i]);
            }
        };

        // Set up the fields to view-only
        if (viewOnly) {
            abcsetup.form_manager.form.find(':input').each(function() {
                if (!$(this).hasClass('hide') && $(this).attr('type') != 'hidden') {
                    if ($(this).prop('nodeName') == 'SELECT') {
                        $(this).attr('disabled', true).addClass('view-only').attr('title', '');
                    } else {
                        // Create a text field so the custom attributes still work
                        var val = $(this).val();
                        var new_val = val.replace(/"/g, "&quot;");
                        if ($(this).prop('nodeName') == 'TEXTAREA') {
                            $(this).replaceWith('<textarea id="' + $(this).attr('id') + '" class="form-control view-only" readonly>'+ new_val +'</textarea>');
                        }
                        else {
                            $(this).replaceWith('<input type="text" id="' + $(this).attr('id') + '" class="form-control view-only" value="' + new_val + '" readonly>');
                        }
                    }
                }
            });
        }
    },


    /**
     * Loop through the current global abcsetup.item and set form fields values
     * (Create hidden fields for items that don't exist)
     */
    setAndCreate: function(viewOnly = false) {
        for (var i in abcsetup.item) {
            if (abcsetup.item[i] !== null) {
                //console.log(i + '::' + abcsetup.item[i].length + '::' + $.isArray(abcsetup.item[i]));

                //if ($.type(abcsetup.item[i]) != 'object' && $.type(abcsetup.item[i]) != 'array') {
                if ($.type(abcsetup.item[i]) != 'object') {
                    if ((!abcsetup.form_manager.form.find(':input[name="' + i + '"]').length) && (!abcsetup.form_manager.form.find(':input[name^="' + i + '["]').length)) {
                        if ($.type(abcsetup.item[i]) != 'array') {
                            abcsetup.form_manager.form.append('<input type="hidden" id="' + i + '" value="' + abcsetup.item[i] + '">');
                        } else {
                            console.log('setAndCreate:: Array field not found: ' + i);
                        }

                    // Set the existing value
                    } else {
                        //console.log(i + ' :: ' + $.type(abcsetup.item[i]));
                        //this._setFieldValue(i, abcsetup.item[i]);
                    }
                }
            }
        };

        // Loop through the current global abcsetup.item and set form fields values
        this.setFormItems(viewOnly);
    },

    /**
     * Find and set the value of a form field
     *
     * @param {*} name
     * @param {*} value
     */
    _setFieldValue: function(name, value) {
        if ($.type(value) != 'object') {
            // The current value is not an array
            if ($.type(value) != 'array') {
                var field = abcsetup.form_manager.form.find(':input[name="' + name + '"]');

                // The field is a date field
                if (field.attr('type') == 'date') {
                    field.val(moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD'));
                } else if (field.attr('type') == 'month') {
                    field.val(moment(value, 'DD/YYYY').format('YYYY-DD'));
                } else {
                    // Checkboxes should not have their value changed!
                    // But should be checked if the stored value is the same as the cbx val
                    if (field.attr('type') == 'checkbox') {
                        if (value == field.val()) {
                            field.prop('checked',true);
                        } else {
                            field.prop('checked',false);
                        }
                    } else {
                        field.val(value);
                    }
                }

            } else {
                // We're setting the values of bracket_break_pricing
                if (name== 'bracket_break_pricing') {
                    $(value).each(function() {
                        for (var i in this) {
                            if (i == 'min_price' || i == 'max_price' || i == 'uom_cost') {
                                $('input[name="bracket_break_pricing[' + this.type + '][' + this.bracket + '][' + i + ']"]').val(this[i]);
                            }
                        }
                    });
                } else if (name == 'gtin_items') {
                    $(value).each(function() {
                        var gtin_level = this;

                        $('#gtin_grid_items').each(function() {
                            var row = $(this).find('table').find('input:checkbox[value="' + gtin_level.level_id + '"]').closest('tr');
                            row.find('input.form-check-input').prop('checked', true);
                            row.find('input.level_name').val(gtin_level.level_name);
                            row.find('.gtin_saleable_unit').val(gtin_level.saleable_unit);
                            row.find('.gtin_saleable_unit_view').val(gtin_level.saleable_unit);
                            row.find('.gtin_rfid_tag').val(gtin_level.rfid_tag);
                            row.find('.gtin_rfid_tag_view').val(gtin_level.rfid_tag);
                            row.find('.gtin_qty').val(gtin_level.qty);
                            row.find('.gtin_qty_view').val(gtin_level.qty);
                            row.find('.gtin_grid_gtin_14').val(gtin_level.gtin_14);
                            row.find('.gtin_grid_gtin_14_view').val(gtin_level.gtin_14);
                            row.find('.gtin_grid_hibcc').val(gtin_level.hibcc);
                            row.find('.gtin_grid_hibcc_view').val(gtin_level.hibcc);
                            row.find('.mgf').val(gtin_level.mgf);
                            row.find('.mgf_view').val(gtin_level.mgf);
                        });
                    });

                } else if (name == 's_a_p_div') {
                    $(value).each(function() {
                        var sap_division = this;
                        $('#sap_divisions_items').each(function() {
                            var row = $(this).find('table').find('input:checkbox[value="' + sap_division.division + '"]').closest('tr');
                            row.find('input.form-check-input').prop('checked', true);
                            row.find('span.cr').show();
                            row.find('input.division_name').val(sap_division.division_name);
                            row.find('.batch_management').val(sap_division.batch_management);
                            row.find('.replace_item').val(sap_division.replace_item);
                            row.find('.replace_sap_num').val(sap_division.replace_sap_num);
                            row.find('.mpi').val(sap_division.mpi);
                            row.find('.reporting_attr').val(sap_division.reporting_attr);
                        });
                    });

                } else if (name == 'divisions') {
                    $(value).each(function() {
                        const optionText = this.id + ' ' + this.name;
                        const optionValue = this.id;
                        abcsetup.form_manager.form.find('#divisions').append(new Option(optionText, optionValue));
                        abcsetup.form_manager.form.find('#divisions').closest('div.shuttlebox').find('div.shuttlebox-left').find('select.shuttlebox-left option[value="'+optionValue+'"]').remove();
                    });
                } else {
                    abcsetup.form_manager.form.find(':input[name="' + name + '[]"]').val(value);
                }

                // Refresh the shuttlebox
                if(name != 'divisions') {
                    if (abcsetup.form_manager.form.find(':input[name="' + name + '[]"]').hasClass('shuttlebox-right')) {
                        var select_right = abcsetup.form_manager.form.find(':input[name="' + name + '[]"]');
                        var this_shuttlebox = select_right.closest("div.shuttlebox");
                        var select_left = this_shuttlebox.find("select.shuttlebox-left");
                        var sel_val = value;
                        $.each(sel_val, function( index, value ) {
                            if (value != '') {
                                select_right.append(select_left.find("option[value="+value+"]").prop('selected','selected'));
                                select_left.find("option[value="+value+"]").remove();
                            }
                        });
                    }
                }
            }
        }
    },
}
